import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=05a39613&scoped=true&"
import script from "./DeleteUser.vue?vue&type=script&lang=ts&"
export * from "./DeleteUser.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=05a39613&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a39613",
  null
  
)

export default component.exports